'use client';
import React from 'react';
import Link from 'next/link';
import { Home, ShieldCheck, FolderLock, FileUser, UserCircle } from 'lucide-react';
import { haptic } from '@/lib/native/haptics';

interface BottomTabBarProps {
  activeTab?: 'dashboard' | 'certs' | 'cv' | 'vault' | 'profile';
}

const tabs = [
  { key: 'dashboard', label: 'Home', icon: Home, href: '/' },
  { key: 'certs', label: 'Certificates', icon: ShieldCheck, href: '/certificates' },
  { key: 'vault', label: 'Vault', icon: FolderLock, href: '/vault' },
  { key: 'cv', label: 'CV', icon: FileUser, href: '/cv-builder' },
  { key: 'profile', label: 'Profile', icon: UserCircle, href: '/profile' },
] as const;

function blurFocusedField() {
  const active = document.activeElement;
  if (active instanceof HTMLInputElement || active instanceof HTMLTextAreaElement || active instanceof HTMLSelectElement) {
    active.blur();
  }
}

export default function BottomTabBar({ activeTab }: BottomTabBarProps) {
  return (
    <nav className="bottom-tab-bar md:hidden" aria-label="Main navigation">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        return (
          <Link
            key={`tab-${tab.key}`}
            href={tab.href}
            className={`bottom-tab-item ${isActive ? 'active' : ''}`}
            aria-current={isActive ? 'page' : undefined}
            onPointerDown={() => {
              blurFocusedField();
              haptic('light');
            }}
          >
            {isActive && <span className="bottom-tab-indicator" aria-hidden="true" />}
            <tab.icon size={22} strokeWidth={isActive ? 2.5 : 1.75} />
            <span>{tab.label}</span>
          </Link>
        );
      })}
    </nav>
  );
}
